export default __webpack_public_path__ + "2f53db40b0a1c00732f6a58fa9c3b814.png";